import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/common.css'
import '@/common/CommonPlugins.js'
import '@/components/common/globalComponent.js'
import Vuelidate from 'vuelidate'
import 'moment/locale/ko'
import _ from 'lodash'
import VueDaumPostcode from 'vue-daum-postcode'

import '@/assets/css/main.scss'

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.config.productionTip = false
Vue.prototype.$_ = _;
Vue.use(Vuelidate)
Vue.use(VueDaumPostcode, {
  scriptUrl: 'http://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'
})



const app = new Vue({
  render: h => h(App),
  store,
  router,
  methods: {
  }
}).$mount('#app')
window.app = app
